import { FORM_NUMBER_TRACKING_HEADER } from '../../models/form-table-header.model';

export const ReviewFormsHeaders = {
    reviewFormsHeader: [
        // { key: 'form_number_display', label: 'Form Number' },
        { ...FORM_NUMBER_TRACKING_HEADER },
        { key: 'department_name', label: 'Category' },
        { key: 'department_form_name', label: 'Form Name' },
        { key: 'employee_display', label: 'Employee' },
        { key: 'date_assigned_display', label: 'Date Assigned' },
        { key: 'usd_amount_display', label: 'USD Amount' },
        { key: 'status_value', label: 'Status' },
    ],
    myFormsHeader: [
        // { key: 'form_number_display', label: 'Form Number' },
        { ...FORM_NUMBER_TRACKING_HEADER },
        { key: 'department_name', label: 'Category' },
        { key: 'department_form_name', label: 'Form Name' },
        { key: 'employee_display', label: 'Employee' },
        { key: 'next_approver', label: 'Next Approver' },
        { key: 'date_assigned_display', label: 'Date Assigned' },
        { key: 'usd_amount_display', label: 'USD Amount' },
        { key: 'status_value', label: 'Status' },
    ],
    adminHeader: [
        { key: 'full_name', label: 'Full Name' },
        { key: 'email', label: 'Email' },
        { key: 'role_name', label: 'Role' },
        { key: 'department_name', label: 'Department' },
        { key: 'status_value', label: 'Status' }
    ],
    managerHeader: [
        { key: 'template_name', label: 'Template Name' },
        { key: 'form_number_display', label: 'Form Number' },
        { key: 'date_assigned_display', label: 'Date Assigned' },
        { key: 'employee_display', label: 'Employee' },
        { key: 'department_name', label: 'Department Name' },
        { key: 'department_form_name', label: 'Department Form' },
        { key: 'approver_status', label: 'Approver Status' }
    ],
    employeeHeader: [
        // { key: 'form_number_display', label: 'Form Number' },
        { ...FORM_NUMBER_TRACKING_HEADER },
        { key: 'department_name', label: 'Category' },
        { key: 'department_form_name', label: 'Form Name' },
        { key: 'employee_display', label: 'Employee' },
        { key: 'status_display', label: 'Status' },
        { key: 'date_assigned_display', label: 'Date Assigned' },
    ],
    superAdminHeader: [
        { key: 'tenant_name_display', label: 'Tenant Name' },
        { key: 'user_name_display', label: 'User Name' },
        { key: 'user_email_display', label: 'User Email' },
        { key: 'plan_name_display', label: 'Plan Name' },
        { key: 'updated_at_display', label: 'Updated At' },
        { key: 'renewal_date_display', label: 'Renewal Date' }
    ],
    advancedSearchSetupHeader: [
        { key: 'id', label: 'ID' },
        { key: 'department_form_name', label: 'Form Name' },
        { key: 'regions', label: 'Regions' },
        { key: 'user_name', label: 'Employee' },
        { key: 'updated_at', label: 'Updated At' },
    ]
} as const;